import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Licenciador } from 'src/app/models/api/comercial/licenciador';
import { IResponse } from 'src/app/models/api/response.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiLicenciadorService {
  private baseUrl = 'Licenciador';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Licenciador[]>('');
  }
  getAllAtivosInativos() {
    return this.controller.useLoading('waves').get<IResponse<Licenciador[]>>('/BuscarAtivosInativos');
  }
  insert(data: Licenciador) {
    return this.controller.useLoading().post('', data);
  }

  update(data: Licenciador) {
    return this.controller.useLoading().put('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.useLoading().delete(id);
  }
}
